const type = process.env.REACT_APP_SECRET_BUILD_TYPE || 'development'
const IS_DEV = type === 'development'
const IS_PRO = type === 'production'
const runtimeConfig = (window as any).CocoFaxRuntimeConfig || {}
const getRuntimeConfig = (key: string, fallback?: string) =>
  typeof runtimeConfig[key] === 'undefined' ? fallback : runtimeConfig[key]
//@ts-ignore
const IS_ELECTRON = window.IS_ELECTRON ? true : false
// eslint-disable-next-line
const IS_TEST = getRuntimeConfig('isTest', process.env.REACT_APP_CONFIG_IS_TEST) == '1'

const Config = {
  baseUrl: getRuntimeConfig('baseUrl', process.env.REACT_APP_CONFIG_BASEURL),
  mainDomain: getRuntimeConfig('mainUrl', process.env.REACT_APP_CONFIG_MAINURL),
  appDomain: getRuntimeConfig('appDomain', process.env.REACT_APP_CONFIG_APP_MAINURL),
  cookieDomain: getRuntimeConfig('cookieDomain', process.env.REACT_APP_CONFIG_COOKIE_DOMAIN || 'cocofax.com'),
  testToken: getRuntimeConfig('testToken', process.env.REACT_APP_CONFIG_TEST_TOKEN),
  googleDriveApiKey: getRuntimeConfig('googleDriveApiKey', process.env.REACT_APP_GOOGLE_DRIVE_API_KEY),
  googleDriveClientId: getRuntimeConfig('googleDriveClientId', process.env.REACT_APP_GOOGLE_DRIVE_CLIENT_ID),
  PRICING_URL: `${getRuntimeConfig('mainUrl', process.env.REACT_APP_CONFIG_MAINURL)}/pricing.html`,
  LOGIN_URL: `${getRuntimeConfig('mainUrl', process.env.REACT_APP_CONFIG_MAINURL)}/login.html`,

  Fax: {
    // Recipient
    FreeUserRecipientMaxLen: 1, // 免费用户最大选择收件人数
    UserRecipientMaxLen: 10, // 正常付费用户最大选择收件人数

    SendFileMaxLen: 50, // 发送文档最大数
    SendFileSize: 25, // 发送文档最大值 M 单位
    SendImgFileSize: 2, // 最大图片2M
    // Text
    AddTextMaxLen: 10000, // 添加 Text 文字最长数
    supportImgTypes: ['image/jpeg', 'image/png', 'image/jpg'],
    // out box
    OutBoxRefeshTime: 60 * 1000, // outbox 页面刷新间隔 1 分钟
  },
  User: {
    VerifyEmailCodeTime: 60 * 1000, // 用户验证邮箱 验证码 间隔 1 分钟
  },
  sentryConfig: {
    dsn: 'https://0c0803c9251e404ea372e054b6a04f90@o420643.ingest.sentry.io/5339222',
  },

  amplitude: {
    API_KEY: getRuntimeConfig('amplitudeApiKey', process.env.REACT_APP_SA_API_KEY),
  },
}
// console.log({ IS_DEV, IS_PRO, IS_ELECTRON, IS_TEST, Config })
export { IS_DEV, IS_PRO, IS_ELECTRON, IS_TEST, Config }
